import store from '@/store/index'

export const DASHBOARD_LIST_KEYS = {
  HOTB: 'hotbInfo',
  TENANT_PROJECTS: 'tenantProjects',
  DIRECTORIES: 'directories',
}

/** CommonTable tableId in engineer Directories.vue — purge on stale so mount does not hydrate old rows. */
export const DIRECTORY_ENGINEER_DASHBOARD_TABLE_ID = 'tenancy-directory-requisition-table'

export function markHotbDashboardListStale () {
  store.dispatch('dashboard/markListStale', { dashboard: DASHBOARD_LIST_KEYS.HOTB })
}

export function markTenantProjectsDashboardListStale () {
  store.dispatch('dashboard/markListStale', { dashboard: DASHBOARD_LIST_KEYS.TENANT_PROJECTS })
}

export function markDirectoriesDashboardListStale () {
  store.dispatch('dashboard/markListStale', { dashboard: DASHBOARD_LIST_KEYS.DIRECTORIES })
  store.dispatch('tables/purgeContentListSnapshot', { tableId: DIRECTORY_ENGINEER_DASHBOARD_TABLE_ID })
}

/** Tenancy list fields (company, trade, building, premises) on cached engineer dashboard tabs. */
export function markTenancyDashboardListsStale () {
  markHotbDashboardListStale()
  markTenantProjectsDashboardListStale()
  markDirectoriesDashboardListStale()
}
